(self["webpackChunk"] = self["webpackChunk"] || []).push([[8300],{

/***/ 99584:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 81511:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 41911:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 3212:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 73404:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 47145:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 52446:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var utils_relationships_toggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89314);
/* harmony import */ var utils_relationships_toggle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(utils_relationships_toggle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99584);




/***/ }),

/***/ 98389:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81511);



/***/ }),

/***/ 36844:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./pages/timeline/components/achievements/all_achievements/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/achievements/all_achievements/index.js



/***/ }),

/***/ 57974:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./utils/media_query/index.js
var media_query = __webpack_require__(28925);
;// CONCATENATED MODULE: ./pages/timeline/components/achievements/big_achievement_box/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/achievements/big_achievement_box/index.js


const $context = window.jQuery('.q-profile-page');
window.jQuery('.js-see-all-badges', $context).on('click', function(e) {
    e.preventDefault();
    window.jQuery('.js-badges-tab', $context).tab('show');
});
if (media_query/* MediaQuery.is */.z.is('lt_md')) {
    const $context = '.q-profile-page';
    const goToLink = function() {
        window.jQuery('html,body').animate({
            scrollTop: window.jQuery('#all-badges').offset().top
        }, 'slow');
    };
    window.jQuery('.js-see-all-badges', $context).on('click', function(e) {
        e.preventDefault();
        goToLink();
    });
}


/***/ }),

/***/ 70925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Activity)
});

// EXTERNAL MODULE: ./pages/timeline/components/activity/index.scss
var activity = __webpack_require__(3212);
// EXTERNAL MODULE: ./utils/modal_manager/index.js
var modal_manager = __webpack_require__(87322);
;// CONCATENATED MODULE: ./components/modals/promise_modal/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./components/modals/promise_modal/index.js


/**
 * Populate object for this modal accepts:
 *
 * {
 *   question [string] (optional) 
 *   ok [string] (optional)
 *   cancel [string] (optional)
 *   modalType [string] (optional)
 *   iconName [string] (optional - icon sufix - without .q-icon-)
 * }
 *
 */ // TODO: move this to modal manager if approved and update call below
class PromiseModal extends modal_manager/* default */.Z {
    static modify(selector, modalType, iconName) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        const $modalIcon = window.jQuery('.js-modal-icon', $modalElement);
        if (modalType) {
            $modalElement.attr('data-modal-type', modalType);
            window.jQuery('.q-btn-ok', $modalElement).removeClass('btn-default').removeClass('btn-info').removeClass('btn-success').removeClass('btn-danger').addClass(`btn-${modalType}`);
        }
        if (iconName) {
            $modalIcon.removeClass().addClass(`js-modal-icon q-icon q-icon-${iconName}`);
        }
    }
}
/* harmony default export */ const promise_modal = ({
    call (populate, callback) {
        const modalSelector = '#js-promise-modal';
        const { modalType, iconName } = populate;
        PromiseModal.modify(modalSelector, modalType, iconName);
        PromiseModal.populate(modalSelector, populate);
        PromiseModal.open(modalSelector, callback);
    }
});

// EXTERNAL MODULE: ./pages/timeline/components/activity_comment/index.scss
var activity_comment = __webpack_require__(73404);
// EXTERNAL MODULE: ./pages/timeline/components/activity_reply/index.scss
var activity_reply = __webpack_require__(47145);
;// CONCATENATED MODULE: ./components/modals/abuse_report_modal/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/api_error_handler/index.js
var api_error_handler = __webpack_require__(98973);
;// CONCATENATED MODULE: ./utils/translate_error_code/index.js
function translateErrorCode(errorMessage) {
    const errors = {
        "Couldn't find Commentary": 'Não foi possível encontrar o comentário',
        'translation missing: en.default_obscenity_error_message': 'Sua publicação tem conteúdo impróprio',
        'já está em uso': 'Ops! Você já reportou abuso para este comentário!'
    };
    if (errors[errorMessage]) {
        return errors[errorMessage];
    } else {
        return errorMessage;
    }
}

;// CONCATENATED MODULE: ./utils/error_interpreter/index.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


const errorInterpreter = /*#__PURE__*/ _async_to_generator(function*({ message, response }) {
    const responseJSON = yield response == null ? void 0 : response.json();
    const messageOrDefault = message !== '' ? message : 'Ops! Tivemos um problema';
    if (responseJSON.message) {
        toastr.error(translateErrorCode(responseJSON.message));
        return;
    }
    if (responseJSON.errors.text) {
        toastr.error(translateErrorCode(responseJSON.errors.text[0]));
        return;
    }
    if (responseJSON.errors['stored_filter.subjects_ids']) {
        toastr.error(translateErrorCode(responseJSON.errors['stored_filter.subjects_ids'][0]));
        return;
    }
    if (responseJSON.errors.type) {
        toastr.error(translateErrorCode(responseJSON.errors.type[0]));
        return;
    }
    if (responseJSON.errors.question) {
        toastr.error(translateErrorCode(responseJSON.errors.question[0]));
        return;
    }
    if (responseJSON.errors.user) {
        toastr.error(translateErrorCode(responseJSON.errors.user[0]));
        return;
    }
    (0,api_error_handler/* handleApiError */.z)(messageOrDefault, response);
});

;// CONCATENATED MODULE: ./components/modals/abuse_report_modal/index.js




class AbuseReportModal {
    static openForQuestionsCommentary(data) {
        const { commentId, questionId } = data;
        this._verifyTextArea('.q-route-questions-index, .q-route-questions-show');
        modal_manager/* default.open */.Z.open('#js-abuse-report-modal', (res)=>{
            if (res) {
                Thor.Commentary.report_abuse({
                    id: commentId,
                    question_id: questionId
                }, {
                    data: {
                        text: res.justification
                    }
                }).then(()=>{
                    modal_manager/* default.open */.Z.open('#js-abuse-report-confirm-modal');
                }).catch(({ response })=>{
                    errorInterpreter({
                        response
                    });
                });
            }
        });
    }
    static openForTimelineActivity(data) {
        const { activityId } = data;
        this._verifyTextArea('.q-user-panel-layout');
        modal_manager/* default.open */.Z.open('#js-abuse-report-modal', (res)=>{
            if (res) {
                Thor.Activity.report_abuse({
                    id: activityId
                }, {
                    data: {
                        text: res.justification
                    }
                }).then(()=>{
                    modal_manager/* default.open */.Z.open('#js-abuse-report-confirm-modal');
                }).catch(({ response })=>{
                    (0,api_error_handler/* handleApiError */.z)('Ops! Você já reportou abuso para esta publicação!', response);
                });
            }
        });
    }
    static openForTimelineComment(data) {
        const { commentId, activityId } = data;
        this._verifyTextArea('.q-user-panel-layout');
        modal_manager/* default.open */.Z.open('#js-abuse-report-modal', (res)=>{
            if (res) {
                Thor.ActivityComments.report_abuse({
                    id: commentId,
                    activity_id: activityId
                }, {
                    data: {
                        message: res.justification
                    }
                }).then(()=>{
                    modal_manager/* default.open */.Z.open('#js-abuse-report-confirm-modal');
                }).catch(({ response })=>{
                    (0,api_error_handler/* handleApiError */.z)('Ops! Você já reportou este comentário!', response);
                });
            }
        });
    }
    static openForTimelineReply(data) {
        const { replyId, activityCommentId, activityId } = data;
        this._verifyTextArea('.q-user-panel-layout');
        modal_manager/* default.open */.Z.open('#js-abuse-report-modal', (res)=>{
            if (res) {
                Thor.ActivityReplies.report_abuse({
                    id: replyId,
                    activity_comment_id: activityCommentId,
                    activity_id: activityId
                }, {
                    data: {
                        message: res.justification
                    }
                }).then(()=>{
                    modal_manager/* default.open */.Z.open('#js-abuse-report-confirm-modal');
                }).catch(({ response })=>{
                    (0,api_error_handler/* handleApiError */.z)('Ops! Você já reportou este comentário!', response);
                });
            }
        });
    }
    static _verifyTextArea($context) {
        window.jQuery('#js-justification', $context).off('keyup keydown').on('keyup keydown', function() {
            const currentValue = window.jQuery('#js-justification', $context).val();
            const $justificationButton = window.jQuery('.js-btn-justification', $context);
            if (currentValue.length >= 3) {
                $justificationButton.removeAttr('disabled');
            } else {
                $justificationButton.attr('disabled', 'disabled');
            }
            window.jQuery('.js-btn-justification-cancel', $context).on('click', function() {
                window.jQuery('#js-justification', $context).val('');
                $justificationButton.attr('disabled', 'disabled');
            });
        });
    }
}


;// CONCATENATED MODULE: ./pages/timeline/components/activity_reply/index.js




class ActivityReply {
    /**
   *
   * ActivityReply API
   * publish | delete | report | update (disabled)
   *
   */ static publish(message, activityId, parentCommentId) {
        if (!message || !parentCommentId) return;
        return Thor.ActivityReplies.create_and_render({
            activity_id: activityId,
            activity_comment_id: parentCommentId
        }, {
            data: {
                reply: {
                    message
                },
                component_name: 'timeline/activity_reply'
            }
        });
    }
    static delete(activityId, parentCommentId, replyId) {
        return new Promise((resolve, reject)=>{
            promise_modal.call({
                question: 'Tem certeza que deseja deletar esse comentário?',
                modalType: 'danger'
            }, (res)=>{
                if (res) {
                    Thor.ActivityReplies.delete({
                        activity_id: activityId,
                        activity_comment_id: parentCommentId,
                        id: replyId
                    }).then((response)=>resolve(response)).catch((err)=>reject(err));
                } else {
                    reject('Usuário cancelou a ação');
                }
            });
        });
    }
    static report(activityId, activityCommentId, replyId, reason) {
        return Thor.ActivityReplies.report_abuse({
            id: replyId,
            activity_comment_id: activityCommentId,
            activity_id: activityId
        }, {
            data: {
                text: reason
            }
        });
    }
    // This is disabled for now
    // static update(activityId, parentCommentId, replyId, message) {
    //   return new Promise((resolve, reject) => {
    //     Thor.ActivityReplies
    //       .update({
    //         activity_id: activityId,
    //         activity_comment_id: parentCommentId,
    //         id: replyId
    //       }, {
    //         data: {
    //           reply: {
    //             message
    //           },
    //           component_name: 'timeline/activity_reply'
    //         }
    //       })
    //       .then(response => resolve(response))
    //       .catch((err) => reject(err));
    //   });
    // }
    /**
   *
   * ActivityReply User Actions
   * Delete | Report | Update (disabled)
   *
   */ bindReplyDeleteButton() {
        if (!this.$deleteButton) return;
        this.$deleteButton.on('click', (e)=>{
            e.preventDefault();
            this.constructor.delete(this.activityId, this.parentCommentId, this.replyId).then(()=>{
                this.$reply.slideUp(300, ()=>this.$reply.remove());
            }).catch((err)=>console.log(err));
        });
    }
    bindReplyReportButton() {
        if (!this.$reportButton) return;
        this.$reportButton.on('click', (e)=>{
            e.preventDefault();
            AbuseReportModal.openForTimelineReply({
                activityId: this.activityId,
                activityCommentId: this.parentCommentId,
                replyId: this.replyId
            });
        });
    }
    // This is disabled for now
    // TODO : refactor this to trigger a modal that receives a message to update the reply
    // bindReplyUpdateButton() {
    //   if(!this.$updateButton) return;
    //   this.$updateButton.on('click', e => {
    //     e.preventDefault();
    //     const message = 'testing update';
    //     this.constructor.update(this.activityId, this.parentCommentId, this.replyId, message)
    //       .then(response => console.log(response))
    //       .catch(err => console.log(err));
    //   });
    // }
    /**
   *
   * ActivityReply Extras
   * Moment humanized dates
   *
   */ bindReplyDates() {
        this.$dates.toArray().forEach((date)=>{
            date.innerHTML = moment(date.getAttribute('datetime'), moment.ISO_8601).locale('pt-br').fromNow();
        });
    }
    bindAll() {
        this.bindReplyDeleteButton();
        // This is disabled for now
        // this.bindReplyUpdateButton();
        this.bindReplyReportButton();
        this.bindReplyDates();
    }
    constructor(reply){
        if (reply.activityReplyInstance) return;
        this.$reply = window.jQuery(reply);
        this.replyId = reply.dataset.commentId;
        this.activityId = reply.dataset.commentActivityId;
        this.parentCommentId = reply.dataset.parentCommentId;
        this.$dates = window.jQuery('.js-activity-reply-datetime', this.$reply);
        // This is disabled for now
        // this.$updateButton = $('.js-reply-update', this.$reply);
        this.$deleteButton = window.jQuery('.js-activity-reply-delete', this.$reply);
        this.$reportButton = window.jQuery('.js-activity-reply-report', this.$reply);
        this.bindAll();
        reply.activityReplyInstance = this;
    }
}


// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
;// CONCATENATED MODULE: ./pages/timeline/components/activity_replies_list/index.js

class ActivityRepliesList {
    static getList(activityId, parentId, page = 1) {
        return ajax_component_loader/* default.load */.Z.load({
            component: 'timeline/activity_replies_list',
            type: 'page_component',
            data: {
                activity_id: activityId,
                activity_comment_id: parentId
            },
            params: {
                page
            }
        });
    }
}


;// CONCATENATED MODULE: ./pages/timeline/components/activity_comment/index.js






class ActivityComment {
    /**
   * ActivityComment API
   * publish | delete | report | update (disabled)
   */ static publish(message, activityId) {
        if (!message || !activityId) return;
        return Thor.ActivityComments.create_and_render({
            activity_id: activityId
        }, {
            data: {
                comment: {
                    message
                },
                component_name: 'timeline/activity_comment'
            }
        });
    }
    static delete(activityId, commentId) {
        return new Promise((resolve, reject)=>{
            promise_modal.call({
                question: 'Tem certeza que deseja deletar esse comentário?',
                modalType: 'danger'
            }, (res)=>{
                if (res) {
                    Thor.ActivityComments.delete({
                        activity_id: activityId,
                        id: commentId
                    }).then((response)=>resolve(response)).catch((err)=>reject(err));
                } else {
                    reject('Usuário cancelou a ação');
                }
            });
        });
    }
    static report(activityId, commentId, reason) {
        return Thor.ActivityComments.report_abuse({
            id: commentId,
            activity_id: activityId
        }, {
            data: {
                text: reason
            }
        });
    }
    // This is disabled for now
    // static update(activityId = this.activityId, commentId = this.commentId, message) {
    //   return new Promise((resolve, reject) => {
    //     Thor.ActivityComments
    //       .update({
    //         activity_id: activityId,
    //         id: commentId
    //       }, {
    //         data: {
    //           comment: {
    //             message
    //           },
    //           component_name: 'timeline/activity_comment'
    //         }
    //       })
    //       .then(response => resolve(response))
    //       .catch((err) => reject(err));
    //   });
    // }
    /**
   * ActivityComment User Actions
   * Delete | Report | Update (disabled)
   */ bindCommentDeleteButton() {
        if (!this.$deleteButton) return;
        this.$deleteButton.on('click', (e)=>{
            e.preventDefault();
            this.constructor.delete(this.activityId, this.commentId).then(()=>{
                this.$comment.slideUp(300, ()=>this.$comment.remove());
            }).catch((err)=>console.log(err));
        });
    }
    bindCommentReportButton() {
        if (!this.$reportButton) return;
        this.$reportButton.on('click', (e)=>{
            e.preventDefault();
            AbuseReportModal.openForTimelineComment({
                activityId: this.activityId,
                commentId: this.commentId
            });
        });
    }
    // This is disabled for now
    // TODO : refactor this to trigger a modal that receives a message to update the comment
    // bindCommentUpdateButton() {
    //   if(!this.$updateButton) return;
    //   this.$updateButton.on('click', e => {
    //     e.preventDefault();
    //     const message = 'testing update';
    //     this.constructor.update(this.activityId, this.parentCommentId, this.replyId, message)
    //       .then(response => console.log(response))
    //       .catch(err => console.log(err));
    //   });
    // }
    /**
   *
   * ActivityComment Logic for Replies
   * Bind Publish Reply Button | Bind Load Replies Button | Bind Reply Textarea
   *
   */ fetchReplies(firstLoad = true, page = 1, cb) {
        const repliesListLoaded = this.$comment.data('replies-list-loaded');
        if (this.commentHasReplies && (!firstLoad || !repliesListLoaded)) {
            this.$repliesLoadButton.addClass('loading').attr('disabled', 'disabled');
            ActivityRepliesList.getList(this.activityId, this.commentId, page).then((html)=>{
                this.$repliesThread.append(html).find(this.replySelectorClass).toArray().forEach((reply)=>new ActivityReply(reply));
                this.$comment.data('replies-list-loaded', true);
                this.$repliesLoadButton.removeClass('loading').removeAttr('disabled');
                this.$repliesThread.parent().collapse('show');
                if (cb && typeof cb === 'function') cb(true);
            }).catch((err)=>{
                console.log(err);
                this.$comment.data('replies-list-loaded', false);
                this.$repliesLoadButton.removeClass('loading').removeAttr('disabled');
                if (cb && typeof cb === 'function') cb(false);
            });
        } else {
            this.$comment.attr('data-replies-list-loaded', true);
        }
    }
    bindReplyPublishButton() {
        this.$replyPublishButton.on('click', ()=>{
            this.$replyPublishButton.attr('disabled', 'disabled');
            ActivityReply.publish(this.$replyTextarea.val(), this.activityId, this.commentId).then((reponse)=>{
                this.$replyPublishButton.attr('disabled', false);
                this.$repliesThread.append(reponse.data);
                new ActivityReply(this.$repliesThread.find(this.replySelectorClass).last().get(0));
                this.$replyTextarea.val('').removeClass('loading');
                this.$replyTextarea.get(0).dispatchEvent(new Event('autosize:update'));
            }).catch(({ response })=>{
                this.$replyPublishButton.attr('disabled', false);
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível criar a sua resposta nesse momento!', response);
            });
        });
    }
    bindReplyLoadButton() {
        this.$repliesLoadButton.on('click', (e)=>{
            if (this.$comment.data('replies-list-loaded')) return;
            e.preventDefault();
            this.fetchReplies();
        });
    }
    bindReplyLoadButtonMoreButton() {
        this.$comment.off('click.comment', '.js-comment-replies-load-more-btn').on('click.comment', '.js-comment-replies-load-more-btn', (e)=>{
            e.preventDefault();
            const $btn = window.jQuery(e.currentTarget);
            $btn.addClass('loading');
            const page = $btn.data('next-page');
            this.fetchReplies(false, page, (success)=>{
                if (success) {
                    $btn.parent().remove();
                } else {
                    $btn.removeClass('loading');
                }
            });
        });
    }
    bindReplyTextarea() {
        autosize(this.$replyTextarea.get(0));
        this.$replyTextarea.keyup(()=>{
            this.$replyTextarea.val().length >= 2 ? this.$replyTextarea.addClass('submitabble') : this.$replyTextarea.removeClass('submitabble');
        });
    }
    /**
   *
   * ActivityComment Extras
   * Moment humanized dates
   *
   */ bindCommentDates() {
        this.$dates.toArray().forEach((date)=>{
            date.innerHTML = moment(date.getAttribute('datetime'), moment.ISO_8601).locale('pt-br').fromNow();
        });
    }
    bindAll() {
        this.bindCommentDeleteButton();
        this.bindCommentReportButton();
        // This is disabled for now
        // this.bindCommentUpdateButton();
        this.bindReplyLoadButton();
        this.bindReplyLoadButtonMoreButton();
        this.bindReplyPublishButton();
        this.bindReplyTextarea();
        this.bindCommentDates();
    }
    constructor(comment){
        if (comment.activityCommentInstance) return;
        this.$comment = window.jQuery(comment);
        this.commentHasReplies = comment.dataset.commentHasReplies;
        this.commentId = comment.dataset.commentId;
        this.activityId = comment.dataset.commentActivityId;
        this.parentCommentId = comment.dataset.parentCommentId;
        this.$dates = window.jQuery('.js-activity-comment-datetime', this.$comment);
        // This is disabled for now
        // this.$updateButton = $('.js-comment-update', this.$comment);
        this.$deleteButton = window.jQuery('.js-activity-comment-delete', this.$comment);
        this.$reportButton = window.jQuery('.js-activity-comment-report', this.$comment);
        this.$replyTextarea = window.jQuery('.js-activity-comment-reply-textarea', this.$comment);
        this.$repliesThread = window.jQuery('.js-activity-comment-replies-thread', this.$comment);
        this.$repliesLoadButton = window.jQuery('.js-activity-comment-replies-load-btn', this.$comment);
        this.$replyPublishButton = window.jQuery('.js-activity-comment-reply-publish-btn', this.$comment);
        this.replySelectorClass = '.js-activity-reply';
        this.bindAll();
        comment.activityCommentInstance = this;
    }
}


;// CONCATENATED MODULE: ./pages/timeline/components/activity_comments_list/index.js

class ActivityCommentsList {
    static getList(activityId, page = 1) {
        return ajax_component_loader/* default.load */.Z.load({
            component: 'timeline/activity_comments_list',
            type: 'page_component',
            data: {
                activity_id: activityId
            },
            params: {
                page
            }
        });
    }
}


;// CONCATENATED MODULE: ./pages/timeline/components/activity/index.js






class Activity {
    /**
   *
   * Activity API
   * publish | delete | report | update (disabled)
   *
   */ static publish(message) {
        return Thor.Activity.create_and_render({}, {
            data: {
                activity: {
                    message
                },
                component_name: 'timeline/activity'
            }
        });
    }
    static delete(activityId = this.activityId) {
        return new Promise((resolve, reject)=>{
            promise_modal.call({
                question: 'Tem certeza que deseja deletar essa publicação?',
                modalType: 'danger'
            }, (res)=>{
                if (res) {
                    Thor.Activity.delete({
                        id: activityId
                    }).then((response)=>resolve(response)).catch((err)=>reject(err));
                } else {
                    reject('Usuário cancelou a ação');
                }
            });
        });
    }
    static report(activityId, reason) {
        return Thor.Activity.report_abuse({
            id: activityId
        }, {
            data: {
                text: reason
            }
        });
    }
    // This is disabled for now
    // static update(activityId = this.activityId, message) {
    //   return new Promise((resolve, reject) => {
    //     Thor.Activity
    //       .update({
    //         id: activityId
    //       }, {
    //         data: {
    //           activity: {
    //             message
    //           },
    //           component_name: 'timeline/activity'
    //         }
    //       })
    //       .then(response => resolve(response))
    //       .catch((err) => reject(err));
    //   });
    // }
    /**
   *
   * Activity logic for Comments
   * Bind Publish Comment Button | Bind Load Comments Button | Bind Comment Textarea
   *
   */ fetchComments(firstLoad = true, page = 1, cb) {
        const commentListLoaded = this.$activity.data('activity-comments-list-loaded');
        if (this.activityHasComments && (!firstLoad || !commentListLoaded)) {
            this.$commentsLoadButton.addClass('loading').attr('disabled', 'disabled');
            ActivityCommentsList.getList(this.activityId, page).then((html)=>{
                this.$commentsLoadButton.removeClass('loading').slideUp(200, ()=>{
                    this.$commentsThread.append(html).find(this.commentSelectorClass).toArray().forEach((comment)=>new ActivityComment(comment));
                    this.$activity.attr('data-activity-comments-list-loaded', true);
                    if (cb && typeof cb === 'function') cb(true);
                });
            }).catch((err)=>{
                console.log(err);
                this.$commentsLoadButton.removeClass('loading').attr('disabled', false);
                this.$activity.attr('data-activity-comments-list-loaded', false);
                if (cb && typeof cb === 'function') cb(false);
            });
        } else {
            this.$activity.attr('data-activity-comments-list-loaded', true);
            this.$commentsLoadButton.removeClass('loading');
        }
    }
    bindCommentsLoadButton() {
        this.$commentsLoadButton.off('click.activity').on('click.activity', (e)=>{
            e.preventDefault();
            this.fetchComments();
        });
    }
    bindCommentsLoadMoreButton() {
        this.$activity.off('click.activity', '.js-activity-comments-load-more-btn').on('click.activity', '.js-activity-comments-load-more-btn', (e)=>{
            e.preventDefault();
            const $btn = window.jQuery(e.currentTarget);
            $btn.addClass('loading');
            const page = $btn.data('next-page');
            this.fetchComments(false, page, (success)=>{
                if (success) {
                    $btn.parent().remove();
                } else {
                    $btn.removeClass('loading');
                }
            });
        });
    }
    bindCommentPublishButton() {
        this.$commentPublishButton.on('click', ()=>{
            this.$commentPublishButton.attr('disabled', 'disabled');
            ActivityComment.publish(this.$commentTextarea.val(), this.activityId).then((response)=>{
                const count = Number(this.$activity.data('activity-comments-count'));
                this.$activity.attr('data-activity-comments-count', count + 1);
                this.$commentsThread.append(response.data);
                const addedComment = window.jQuery(this.commentSelectorClass, this.$commentsThread).last().get(0);
                new ActivityComment(addedComment);
                this.$commentTextarea.val('').removeClass('loading');
                this.$commentPublishButton.attr('disabled', false);
                this.$commentTextarea.get(0).dispatchEvent(new Event('autosize:update'));
            }).catch(({ response })=>{
                this.$commentPublishButton.attr('disabled', false);
                (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível criar o seu comentário nesse momento!', response);
            });
        });
    }
    bindCommentTextarea() {
        autosize(this.$commentTextarea.get(0));
        this.$commentTextarea.keyup(()=>{
            this.$commentTextarea.val().length > 2 ? this.$commentTextarea.addClass('submitabble') : this.$commentTextarea.removeClass('submitabble');
        });
    }
    /**
   *
   * Activity User Actions
   * Delete | Report | Update (disabled)
   *
   */ bindActivityDeleteButton() {
        if (!this.$deleteButton) return;
        this.$deleteButton.on('click', (e)=>{
            e.preventDefault();
            this.constructor.delete(this.activityId, this.parentCommentId, this.replyId).then(()=>{
                this.$activity.slideUp(300, ()=>this.$activity.remove());
            }).catch((err)=>console.log(err));
        });
    }
    bindActivityReportButton() {
        if (!this.$reportButton) return;
        this.$reportButton.on('click', (e)=>{
            e.preventDefault();
            AbuseReportModal.openForTimelineActivity({
                activityId: this.activityId
            });
        });
    }
    // This is disabled for now
    // TODO : refactor this to trigger a modal that receives a message to update the activity
    // bindActivityUpdateButton() {
    //   if(!this.$updateButton) return;
    //   this.$updateButton.on('click', e => {
    //     e.preventDefault();
    //     const message = 'testing update';
    //     this.constructor.update(this.activityId, this.parentCommentId, this.replyId, message)
    //       .then(response => console.log(response))
    //       .catch(err => console.log(err));
    //   });
    // }
    /**
   *
   * ActivityComment Extras
   * Moment humanized dates
   *
   */ bindDates() {
        this.$dates.toArray().forEach((date)=>{
            date.innerHTML = moment(date.getAttribute('datetime'), moment.ISO_8601).locale('pt-br').fromNow();
        });
    }
    bindAll() {
        this.bindActivityDeleteButton();
        this.bindActivityReportButton();
        // This is disabled for now
        // this.bindActivityUpdateButton();
        this.bindCommentsLoadButton();
        this.bindCommentsLoadMoreButton();
        this.bindCommentPublishButton();
        this.bindCommentTextarea();
        this.bindDates();
    }
    constructor(activity){
        if (activity.activityInstance) return;
        this.$activity = window.jQuery(activity);
        this.activityId = activity.dataset.activityId;
        this.activityHasComments = activity.dataset.activityHasComments;
        this.activityCommentsCount = activity.dataset.activityCommentsCount;
        this.$dates = window.jQuery('.js-activity-datetime', this.$activity);
        // This is disabled for now
        // this.$updateButton = $('.js-activity-update', this.$activity);
        this.$deleteButton = window.jQuery('.js-activity-delete', this.$activity);
        this.$reportButton = window.jQuery('.js-activity-report', this.$activity);
        this.$commentTextarea = window.jQuery('.js-activity-comment-textarea', this.$activity);
        this.$commentsLoadButton = window.jQuery('.js-activity-comments-load-btn', this.$activity);
        this.$commentPublishButton = window.jQuery('.js-activity-comment-publish-btn', this.$activity);
        this.$commentsThread = window.jQuery('.js-activity-comments-thread', this.$activity);
        this.commentSelectorClass = '.js-activity-comment';
        this.bindAll();
        activity.activityInstance = this;
    }
}



/***/ }),

/***/ 58459:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./pages/timeline/components/activity/index.js + 10 modules
var activity = __webpack_require__(70925);
;// CONCATENATED MODULE: ./pages/timeline/components/new_activity/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/api_error_handler/index.js
var api_error_handler = __webpack_require__(98973);
// EXTERNAL MODULE: ./utils/event_manager/index.js
var event_manager = __webpack_require__(69705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/autosize@4.0.2/node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__(47341);
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);
;// CONCATENATED MODULE: ./pages/timeline/components/new_activity/index.js





class NewActivity {
    _resetTextarea($newActivityTextarea, $submitButton, message) {
        $submitButton.removeClass('loading');
        this._setNewActivityTextareaValue($newActivityTextarea, message);
    }
    _getNewActivityTextareaValue($newActivityTextarea) {
        return this._editor ? $newActivityTextarea.html() : $newActivityTextarea.val();
    }
    _setNewActivityTextareaValue($newActivityTextarea, value) {
        if (this._editor) {
            $newActivityTextarea.html(value);
        } else {
            $newActivityTextarea.val(value);
        }
    }
    _setNewActivityTextarea($messageForm) {
        return this._editor ? window.jQuery('.ql-editor', $messageForm) : window.jQuery('.js-new-activity-textarea', $messageForm);
    }
    _configureS3() {
        const bucketName = gon.timeline_bucket_name;
        const bucketRegion = gon.timeline_bucket_region;
        const identityPoolId = gon.timeline_s3_identity_pool_id;
        window.AWS.config.update({
            region: bucketRegion,
            credentials: new window.AWS.CognitoIdentityCredentials({
                IdentityPoolId: identityPoolId
            })
        });
        this.s3 = new window.AWS.S3({
            apiVersion: '2006-03-01',
            params: {
                Bucket: bucketName
            }
        });
    }
    _quillInsertToEditor(url) {
        const range = this._editor.getSelection();
        this._editor.insertEmbed(range.index, 'image', url);
    }
    _quillAddImage(file) {
        const self = this;
        const randomId = new Date().getTime();
        const fileName = `${randomId + '.' + file.name.split('.').pop()}`;
        this.s3.upload({
            Key: fileName,
            Body: file,
            ACL: 'public-read'
        }, function(err, data) {
            if (err) {
                toastr.error('Ops! Ocorreu um erro ao enviar sua foto!');
                Rollbar.error(err.message, err);
            }
            self._quillInsertToEditor(data.Location);
        });
    }
    _quillSelectLocalImage() {
        const self = this;
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = ()=>{
            const file = input.files[0];
            if (/^image\//.test(file.type)) {
                self._quillAddImage(file);
            } else {
                toastr.error('Ops! Você só pode enviar imagens');
            }
        };
    }
    _instantiateQuill() {
        const placeholder = window.jQuery('.js-new-activity').data().placeholder;
        this._editor = new Quill('.js-editor-container', {
            modules: {
                toolbar: [
                    [
                        'bold',
                        'italic',
                        'underline',
                        'link'
                    ],
                    [
                        {
                            color: [
                                false,
                                'red',
                                'green',
                                'blue'
                            ]
                        }
                    ],
                    [
                        'image'
                    ]
                ]
            },
            placeholder: placeholder,
            theme: 'snow'
        });
        this._editor.getModule('toolbar').addHandler('image', ()=>{
            this._quillSelectLocalImage();
        });
    }
    _createEventInActivityArea($newActivityTextarea) {
        $newActivityTextarea.on('focus', ()=>{
            $newActivityTextarea.parents('.q-dialog').addClass('q-dialog--focused');
        }).on('blur', ()=>{
            $newActivityTextarea.parents('.q-dialog').removeClass('q-dialog--focused');
        });
    }
    _toggleSubmitButton($submitButton, res) {
        $submitButton.attr('disabled', res ? false : 'disabled');
    }
    _publishActivity(message, $submitButton, $newActivityTextarea) {
        activity/* default.publish */.Z.publish(message).then((response)=>{
            $submitButton.attr('disabled', false).removeClass('loading');
            $newActivityTextarea.get(0).dispatchEvent(new Event('autosize:update'));
            event_manager/* EventManager.publish */.Q.publish('timeline.activity.new', response.data);
        }).catch(({ response })=>{
            this._resetTextarea($newActivityTextarea, $submitButton, message);
            (0,api_error_handler/* handleApiError */.z)('Ops! Não foi possível criar a sua publicação nesse momento!', response);
        });
    }
    _createEventInSubmitButton($submitButton, $newActivityTextarea) {
        $newActivityTextarea.keyup(()=>{
            let isValid = this._getNewActivityTextareaValue($newActivityTextarea).length > 2;
            this._toggleSubmitButton($submitButton, isValid);
        });
        $submitButton.on('click', (e)=>{
            e.preventDefault();
            let message = this._getNewActivityTextareaValue($newActivityTextarea);
            this._setNewActivityTextareaValue($newActivityTextarea, '');
            $submitButton.attr('disabled', 'disabled').addClass('loading');
            this._publishActivity(message, $submitButton, $newActivityTextarea);
        });
    }
    _performsMainInteraction() {
        const $messageForm = window.jQuery('.js-new-activity-form');
        const $newActivityTextarea = this._setNewActivityTextarea($messageForm);
        const $submitButton = window.jQuery('.js-new-activity-submit-btn', $messageForm);
        vendorManager.ensure('autosize', ()=>{
            autosize_default()($newActivityTextarea.get(0));
        });
        this._createEventInActivityArea($newActivityTextarea);
        this._createEventInSubmitButton($submitButton, $newActivityTextarea);
    }
    _performByRole() {
        if (window.jQuery('.js-editor-container', this.$context).length === 0) {
            this._performsMainInteraction();
        } else {
            vendorManager.ensure('quill', ()=>{
                this._instantiateQuill();
                this._performsMainInteraction();
            });
        }
    }
    constructor($context){
        const $component = window.jQuery('.q-timeline-page');
        this.$context = $context;
        if (gon.qc_user || gon.institutional_publisher) {
            this._configureS3();
        }
        if ($component.length) {
            this._performByRole();
        }
    }
}
(function() {
    new NewActivity('.js-new-activity-form');
})();


/***/ }),

/***/ 39696:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/notebooks/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/notebooks/index.js


;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/notebooks_card/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/notebooks_card/index.js


;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/contents/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/contents/index.js


;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/statistics_container/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/statistics_container/index.js


// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
;// CONCATENATED MODULE: ./pages/timeline/components/resources_box/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}






(function($) {
    'use strict';
    const container = $('.js-q-resources-box-statistics-container');
    const params = container.data();
    if (params) {
        ajax_component_loader/* default.load */.Z.load({
            component: 'timeline/resources_box/statistics_container',
            type: 'page_component',
            data: _extends({}, params)
        }).then((element)=>{
            return container.replaceWith(element);
        });
    }
})(window.jQuery);


/***/ }),

/***/ 82861:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/button_follow_user/index.js
var button_follow_user = __webpack_require__(52446);
;// CONCATENATED MODULE: ./pages/timeline/components/sidebar_box/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/sidebar_box/network.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/sidebar_box/network_indications.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/sidebar_box/index.js






/***/ }),

/***/ 5415:
/***/ (() => {

"use strict";

;// CONCATENATED MODULE: ./pages/timeline/components/timeline_filter/index.scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./pages/timeline/components/timeline_filter/index.js

window.jQuery(function($1) {
    const $component = $1('.q-timeline-page');
    if ($component) {
        const $filter = $component.find('#js-timeline-filter');
        const $label = $filter.find('#timeline-filter-dropdown');
        const $form = $filter.find('#js-timeline-filter-form');
        $form.find('input[name="timeline-filter"]').change((e)=>{
            let selectedValue = $1(e.currentTarget).data('label');
            $1($label).find('span').html(selectedValue);
            Turbolinks.visit($1(e.currentTarget).data('url'));
        });
        $1('.js-open-new-activity').off('click').on('click', (event)=>{
            $component.find('.q-new-activity').removeClass('hidden');
            $1(event.currentTarget).hide();
        });
    }
}(window.jQuery));


/***/ }),

/***/ 86404:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

;// CONCATENATED MODULE: ./pages/timeline/components/timeline_loader/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./utils/event_manager/index.js
var event_manager = __webpack_require__(69705);
;// CONCATENATED MODULE: ./pages/timeline/components/timeline_loader/index.js


(function($) {
    const $component = $('.q-timeline-page');
    const $timelineLoader = $('.js-timeline-loader', $component);
    if ($component) {
        const pageLoaded = (msg, data)=>{
            $timelineLoader.removeClass('loading');
            if (data.last) {
                $timelineLoader.hide();
            } else {
                $timelineLoader.show();
            }
        };
        $timelineLoader.click(()=>{
            $timelineLoader.addClass('loading');
            event_manager/* EventManager.publish */.Q.publish('timeline.page.load');
        });
        event_manager/* EventManager.subscribe */.Q.subscribe('timeline.page.loaded', pageLoaded);
    }
})(window.jQuery);


/***/ }),

/***/ 30849:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Timeline)
});

;// CONCATENATED MODULE: ./pages/timeline/lib/index.scss
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./pages/timeline/components/activity/index.js + 10 modules
var components_activity = __webpack_require__(70925);
// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
;// CONCATENATED MODULE: ./pages/timeline/components/activities_list/index.js

class ActivitiesList {
    static getList(page, userId = null, source = null) {
        const data = {};
        if (userId) {
            data.user_id = userId;
        }
        if (source) {
            data.source = source;
        }
        return ajax_component_loader/* default.load */.Z.load({
            component: 'timeline/activities_list',
            type: 'page_component',
            data: data,
            params: {
                page
            }
        });
    }
}


;// CONCATENATED MODULE: ./utils/query_string/index.js
class QueryString {
    static getQueryStringData(qs = null) {
        const uriSearch = qs || location.search;
        let str = decodeURIComponent(uriSearch);
        if (typeof str !== 'string') return {};
        str = str.trim().replace(/^\?/, '');
        if (!str) return {};
        return str.trim().split('&').reduce(function(ret, param) {
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            val = val === undefined ? null : val;
            if (ret[key] && Array.isArray(ret[key])) {
                const index = ret[key].indexOf(val);
                if (index < 0) ret[key].push(val);
            } else {
                if (key.indexOf('[]') > -1) ret[key] = [
                    val
                ];
                else ret[key] = val;
            }
            return ret;
        }, {});
    }
    static parseQueryStringData(obj) {
        return window.jQuery.param(obj);
    }
}


// EXTERNAL MODULE: ./utils/event_manager/index.js
var event_manager = __webpack_require__(69705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/rollbar@2.7.0/node_modules/rollbar/dist/rollbar.umd.min.js
var rollbar_umd_min = __webpack_require__(47125);
var rollbar_umd_min_default = /*#__PURE__*/__webpack_require__.n(rollbar_umd_min);
;// CONCATENATED MODULE: ./pages/timeline/lib/timeline.js






class Timeline {
    start() {
        this.activitySelectorClass = '.js-activity';
        this.$component = window.jQuery('.js-timeline');
        this.$timelineFeed = window.jQuery('.js-timeline-feed', this.$component);
        if (!this.$timelineFeed.length) {
            return;
        }
        this.$timelineLoader = window.jQuery('.js-timeline-loader', this.$component);
        if (this.$component.length) {
            vendorManager.ensure('autosize', ()=>{
                vendorManager.ensure('moment', ()=>{
                    event_manager/* EventManager.subscribe */.Q.subscribe('timeline', (msg, data)=>this.delegator(msg, data));
                    // Bootstrapping Timeline
                    this.renderNewActivityPage(1);
                });
            });
        }
    }
    renderNewActivityPage(page = null) {
        const $lastPage = window.jQuery('[data-next-page]', this.$timelineFeed).last();
        const userId = parseInt(this.$timelineFeed.data('user-id'));
        page = page || $lastPage.data('next-page');
        const data = QueryString.getQueryStringData();
        ActivitiesList.getList(page, userId, data.source).then((html)=>{
            this.$timelineFeed.append(window.jQuery(html).addClass('appended'));
            const $page = window.jQuery(`[data-page="${page}"]`, this.$timelineFeed);
            const totalPages = $page.data('total-pages');
            window.jQuery(this.activitySelectorClass, $page).each((i, activity)=>{
                new components_activity/* default */.Z(activity);
            });
            event_manager/* EventManager.publish */.Q.publish('timeline.page.loaded', {
                last: !totalPages || page === totalPages
            });
        }).catch((err)=>rollbar_umd_min_default().error(err));
    }
    renderNewActivity(html) {
        this.$timelineFeed.prepend(window.jQuery(html).addClass('appended'));
        new components_activity/* default */.Z(this.$timelineFeed.find(this.activitySelectorClass).get(0));
        window.jQuery('.js-empty-timeline', this.$component).remove();
    }
    delegator(msg, data) {
        switch(msg){
            case 'timeline.activity.new':
                this.renderNewActivity(data);
                break;
            case 'timeline.page.load':
                this.renderNewActivityPage(data);
                break;
        }
    }
}



/***/ }),

/***/ 62346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ AjaxComponentLoader)
/* harmony export */ });
/* harmony import */ var utils_session_expired__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29483);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86759);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_snakeCase__WEBPACK_IMPORTED_MODULE_1__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


class AjaxComponentLoader {
    static _request($target, component, params, data, resolve, reject) {
        window.jQuery.ajax({
            url: `/components/${component}?${window.jQuery.param(params)}`,
            method: 'POST',
            data,
            success: (res)=>AjaxComponentLoader._success($target, component, res, resolve),
            error: (res)=>AjaxComponentLoader._fail(component, res, reject)
        });
    }
    static _success($target, component, res, cb) {
        if ($target) {
            $target.html(res).addClass('q-component-loaded');
            window.permissions.bindClicks($target);
        }
        if (typeof cb === 'function') cb(res);
        window.jQuery(document).trigger(`componentLoaded:${component}`, {
            context: $target
        });
    }
    static _fail(component, res, cb) {
        if (res.status === 401) {
            utils_session_expired__WEBPACK_IMPORTED_MODULE_0__/* ["default"].renewSessionModal */ .Z.renewSessionModal(location.pathname);
        } else if (res.status !== 0) {
            AjaxComponentLoader.reportToRollbar(component, res);
            if (typeof cb === 'function') cb(res);
        }
    }
    static load(config) {
        const authenticity_token = window.jQuery('body').data('authenticity-token');
        const { target, component, asset_key, type, data_type, params = {} } = config;
        const $target = target ? window.jQuery(target) : null;
        const data = Object.keys(config.data).reduce((cur, key)=>{
            cur[lodash_snakeCase__WEBPACK_IMPORTED_MODULE_1___default()(key)] = config.data[key];
            return cur;
        }, {});
        params.current_product = data.product_key ? data.product_key : 'concursos';
        let requestData = _extends({}, params, {
            data,
            asset_key,
            authenticity_token,
            data_type: data_type || 'hash',
            type: type || 'component'
        });
        return new Promise((resolve, reject)=>{
            AjaxComponentLoader._request($target, component, params, requestData, resolve, reject);
        });
    }
    static reportToRollbar(component, res) {
        Rollbar.error(`AjaxComponentLoader: Erro ao carregar o componente "${component}"`, {
            serverStatusText: res.statusText,
            serverStatus: res.status,
            responseText: res.responseText,
            component: component
        });
    }
}



/***/ }),

/***/ 98973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ handleApiError)
/* harmony export */ });
/* harmony import */ var utils_session_expired__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29483);

function handleApiError(message, error) {
    if ((error == null ? void 0 : error.status) === 401) {
        utils_session_expired__WEBPACK_IMPORTED_MODULE_0__/* ["default"].renewSessionModal */ .Z.renewSessionModal(location.href);
    } else {
        toastr.error(message || 'Ocorreu um erro, tente novamente.');
        if (!(error == null ? void 0 : error.errors)) {
            return Rollbar.error(message, error);
        }
        const errors = Object.keys(error.errors);
        if (errors.length) {
            const errorKey = errors[0];
            const errorMsgs = error.errors[errorKey];
            const errorMsg = errorMsgs.length && errorMsgs[0] || '';
            Rollbar.error(`API response error${errorMsg && `: ${errorKey} ${errorMsg}`}.`, {
                status: error.status,
                statusText: error.statusText,
                responseText: error.responseText
            });
        }
    }
}


/***/ }),

/***/ 69705:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ EventManager)
/* harmony export */ });
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82941);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_0__);
// https://github.com/mroderick/PubSubJS

delete window.PubSub;
window.EventManager = (pubsub_js__WEBPACK_IMPORTED_MODULE_0___default());
const EventManager = window.EventManager;


/***/ }),

/***/ 28925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ MediaQuery)
/* harmony export */ });
window.screenBreakpoints = {
    xs: 'screen and (max-width:768px)',
    sm: 'screen and (min-width:768px)',
    lt_sm: 'screen and (max-width:768px)',
    md: 'screen and (min-width:992px)',
    lt_md: 'screen and (max-width:992px)',
    lg: 'screen and (min-width:1200px)',
    lt_lg: 'screen and (max-width:1200px)',
    header_lg_breakpoint: 'screen and (min-width:1024px)',
    lt_header_lg_breakpoint: 'screen and (max-width:1024px)'
};
class MediaQuery {
    static match(query) {
        return window.matchMedia ? window.matchMedia(query).matches : true;
    }
    static is(size) {
        return MediaQuery.match(window.screenBreakpoints[size]);
    }
}
window.MediaQuery = MediaQuery;


/***/ }),

/***/ 87322:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _serialize_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49539);
/* harmony import */ var _serialize_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_serialize_object__WEBPACK_IMPORTED_MODULE_0__);

class ModalManager {
    static bindForm($modal, callback) {
        const $form = window.jQuery('form', $modal);
        if (!$form.length) {
            return;
        }
        $form.off('submit.form').on('submit.form', (e)=>{
            e.preventDefault();
            const formData = $form.serializeObject();
            $modal.modal('hide');
            callback(formData, window.jQuery(e.currentTarget));
            $form.clearForm();
        });
    }
    static populate(selector, data) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        for(const itemName in data){
            const $element = $modalElement.find(`[data-modal-${itemName}]`);
            const value = data[itemName];
            if ($element.is('button')) {
                value ? $element.show() : $element.hide();
            }
            if ($element.attr('value') !== undefined) {
                $element.val(value);
            } else {
                $element.html(value);
            }
        }
    }
    static bindButtons($modal, callback) {
        window.jQuery('#js-ok-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(true);
            }
        });
        window.jQuery('#js-cancel-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(false);
            }
        });
    }
    static dispatchEvents(selector) {
        const eventName = {
            '#modal-id': 'event name'
        }[selector];
        if (eventName === undefined) {
            return;
        }
        UserTracker.emit('event', {
            eventName
        });
    }
    static open(selector, callback) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        const $modal = $modalElement.modal();
        const isCallbackEnabled = callback && typeof callback === 'function';
        if (isCallbackEnabled) {
            ModalManager.bindForm($modal, callback);
        }
        ModalManager.bindButtons($modal, isCallbackEnabled ? callback : null);
        ModalManager.dispatchEvents(selector);
        $modal.modal('show');
        return $modal;
    }
    static close($modal) {
        $modal.modal('hide');
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalManager);


/***/ }),

/***/ 89314:
/***/ (() => {

(function($) {
    'use strict';
    const unfollow = (targetUserId, $button)=>{
        const { followText, followIcon, followTitle } = $button.data();
        Thor.Relationship.delete({}, {
            qs: {
                followed_id: targetUserId
            }
        }).then(()=>{
            $button.removeClass('is-following').data('is-following', false).attr('data-is-following', false).attr('data-original-title', followTitle).attr('disabled', false).html(followIcon + followText).blur();
        });
    };
    const follow = (targetUserId, $button)=>{
        const { unfollowText, unfollowIcon, unfollowTitle } = $button.data();
        Thor.Relationship.create({}, {
            data: {
                relationship: {
                    followed_id: targetUserId
                }
            }
        }).then(()=>{
            $button.addClass('is-following').data('is-following', true).attr('data-is-following', true).attr('data-original-title', unfollowTitle).attr('disabled', false).html(unfollowIcon + unfollowText).blur();
        });
    };
    $(document).off('click.relationships').on('click.relationships', '.js-relationship', (event)=>{
        if (!$('body').data().isUserSignedIn) {
            return;
        }
        const $button = $(event.currentTarget);
        let { targetUserId, isFollowing, loadingText } = $button.data();
        $button.attr('disabled', true);
        $button.html(loadingText);
        if (isFollowing) {
            unfollow(targetUserId, $button);
        } else {
            follow(targetUserId, $button);
        }
    });
})(window.jQuery);


/***/ }),

/***/ 49539:
/***/ (() => {

/* eslint-disable no-prototype-builtins */ (function($) {
    $.fn.serializeObject = function(castValues = true, alwaysReturnKeys = false) {
        let self = this, json = {}, push_counters = {}, patterns = {
            'validate': /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
            'key': /[a-zA-Z0-9_]+|(?=\[\])/g,
            'push': /^$/,
            'fixed': /^\d+$/,
            'named': /^[a-zA-Z0-9_]+$/
        };
        this.isJsonString = function(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        };
        this.castValues = (obj)=>{
            // eslint-disable-next-line no-unused-vars
            for(const key in obj){
                if (!obj.hasOwnProperty(key)) continue;
                let value = obj[key];
                if (typeof value === 'undefined' || value === null || value.toString().length === 0) continue;
                if (typeof value === 'object') {
                    value = this.castValues(value);
                } else if (value === 'true') {
                    value = true;
                } else if (value === 'false') {
                    value = false;
                } else if (!isNaN(value)) {
                    value = parseFloat(value);
                } else if (this.isJsonString(value)) {
                    value = JSON.parse(value);
                }
                obj[key] = value;
            }
            return obj;
        };
        this.build = function(base, key, value) {
            if (alwaysReturnKeys || value && value.toString().length) base[key] = value;
            return base;
        };
        this.push_counter = function(key) {
            if (push_counters[key] === undefined) {
                push_counters[key] = 0;
            }
            return push_counters[key]++;
        };
        $.each($(this).serializeArray(), function() {
            // skip invalid keys
            if (!patterns.validate.test(this.name)) {
                return;
            }
            let k, keys = this.name.match(patterns.key), merge = this.value, reverse_key = this.name;
            while((k = keys.pop()) !== undefined){
                // adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');
                if (k.match(patterns.push)) {
                    merge = self.build([], self.push_counter(reverse_key), merge);
                } else if (k.match(patterns.fixed)) {
                    merge = self.build([], k, merge);
                } else if (k.match(patterns.named)) {
                    merge = self.build({}, k, merge);
                }
            }
            json = $.extend(true, json, merge);
        });
        return castValues ? this.castValues(json) : json;
    };
})(window.jQuery);


/***/ }),

/***/ 29483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ SessionExpired)
/* harmony export */ });
/* harmony import */ var utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62346);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87322);


class SessionExpired {
    static renewSessionModal(return_url) {
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].load */ .Z.load({
            component: 'modals/session_expired_modal',
            type: 'component',
            data: {
                return_url: return_url
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            if (gon.flags.session_expired_debug) {
                UserTracker.emit('event', {
                    eventName: 'expired session',
                    data: {
                        request_path: window.location.pathname,
                        cookie_my_app_session: Boolean(window.currentUser),
                        cookie_remember_user_token: Boolean(window.currentUser)
                    }
                });
            }
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .Z.open('#js-session-expired-modal');
        }).catch(()=>{
            Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        });
    }
}



/***/ }),

/***/ 91337:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var validate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2259);
/* harmony import */ var validate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(validate__WEBPACK_IMPORTED_MODULE_0__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

// https://github.com/cferdinandi/validate/blob/master/package.json
// import and run validate.init();
const defaultConfig = {
    // Classes and Selectors
    selector: '[data-validate]',
    fieldClass: 'has-error',
    errorClass: 'help-block',
    // Messages
    messageValueMissing: 'Campo obrigatório.',
    messageValueMissingSelect: 'Selecione uma opção.',
    messageTypeMismatchEmail: 'Digite um e-mail válido.',
    messageTypeMismatchURL: 'Insira uma URL válida.',
    messageTooShort: 'Deve ter {minLength} caracteres ou mais.',
    messageTooLong: 'Deve ter {maxLength} caracters ou menos. Você está usando {length} caracteres.',
    messagePatternMismatch: 'Formato inválido.',
    messageBadInput: 'Insira apenas números.',
    messageStepMismatch: 'Selecione um valor válido.',
    messageRangeOverflow: 'Selecione um valor acima de {max}.',
    messageRangeUnderflow: 'Selecione um valor abaixo de {min}.',
    messageGeneric: 'Valor inválido.',
    // Custom
    createFeedbackIcon (className) {
        let node = document.createElement('i');
        node.classList.add('form-control-feedback', 'js-form-control-feedback', 'q-icon', `q-icon-${className}`);
        return node;
    },
    // Form Submission
    disableSubmit: false,
    customValidity: {
        badConfirm: {
            check (field) {
                if (!field.hasAttribute('confirm')) return false;
                const value = field.value;
                const fieldToCompare = field.getAttribute('confirm');
                const fieldToCompareValue = field.form.querySelector(`#${fieldToCompare}`).value;
                return value !== fieldToCompareValue;
            },
            message: 'O valor não é igual.'
        }
    },
    // onSubmit() {},
    // Callbacks
    beforeShowError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-error', 'has-feedback');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('times-circle'));
        }
    },
    // afterShowError(field, error) {}
    beforeRemoveError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-feedback', 'has-success');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('check-circle'));
        }
    }
};
const validator = {
    config: defaultConfig,
    validate: (validate__WEBPACK_IMPORTED_MODULE_0___default()),
    init (config = null) {
        const expandedConfig = _extends({}, defaultConfig, config);
        validate__WEBPACK_IMPORTED_MODULE_0___default().init(expandedConfig);
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (validator);


/***/ })

}]);